import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router(
{
    scrollBehavior(to,from,savePosition)
    {
		// console.log('[坐标]' );
		// console.log(savePosition);
        if(savePosition)
        {
          return savePosition;      // 解决页面从列表页跳转到详情页返回,初始在原来位置
        }else{
          return {x:0,y:0};         // 解决页面跳转后页面高度和前一个页面高度一样
          //return {};         		// 解决页面跳转后页面高度和前一个页面高度一样
        }
    },
    mode: 'history',
    routes:[
        {
            path:'/',
            name:'/',
            meta: {
                title: '日湖科技',
            },
            component:()=>import('@/views/index.vue')
        },
        {
            path:'/index',
            name:'index',
            meta: {
                title: '日湖科技',
            },
            component:()=>import('@/views/index.vue')
        },
        {
            path:'/sys',
            name:'sys',
            meta: {
                title: '系统调试'
            },
            component:()=>import('@/views/sys.vue')
        },
        {
            path:'/auth/login',
            name:'/auth/login',
            meta: {
                title: '注册/登录'
            },
            component:()=>import('@/views/auth/login.vue')
        },
        {
            path:'/auth/phone',
            name:'/auth/phone',
            meta: {
                title: '注册/登录'
            },
            component:()=>import('@/views/auth/phone.vue')
        },
        {
            path:'/auth/wechat',
            name:'wechat',
            meta: {
                title: '注册/登录'
            },
            component:()=>import('@/views/auth/wechat.vue')
        },
        {
            path:'/user',
            name:'user',
            meta: {
                title: '我的',
            },
            component:()=>import('@/views/user.vue')
        },
        {
            path:'/cart',
            name:'cart',
            meta: {
                title: '购物车',
                keepAlive: true,
            },
            component:()=>import('@/views/cart.vue')
        },
        {
            path:'/goods',
            name:'goods',
            meta: {
                title: '产品详情',
            },
            component:()=>import('@/views/goods.vue')
        },

		{
			path:'/order/list',
			name:'list',
			meta: {
				title: '订单列表'
			},
			component:()=>import('@/views/order/list.vue')
		},
		{
			path:'/order',
			name:'order',
			meta: {
				title: '订单详情'
			},
			component:()=>import('@/views/order/order.vue')
		},
        {
            path:'/order/submit',
            name:'submit',
            meta: {
                title: '提交订单'
            },
            component:()=>import('@/views/order/submit.vue')
        },
        {
            path:'/order/payment',
            name:'payment',
            meta: {
                title: '订单支付'
            },
            component:()=>import('@/views/order/payment.vue')
        },
        {
            path:'/order/paynotify',
            name:'paynotify',
            meta: {
                title: '支付结果'
            },
            component:()=>import('@/views/order/paynotify.vue')
        },
        {
            path:'/order/cashpay',
            name:'cashpay',
            meta: {
                title: '收银台'
            },
            component:()=>import('@/views/order/cashpay.vue')
        }, 
        {
            path:'/order/cashnotify',
            name:'cashnotify',
            meta: {
                title: '收银台'
            },
            component:()=>import('@/views/order/cashnotify.vue')
        },
        {
            path:'/order/cashkefu',
            name:'cashkefu',
            meta: {
                title: '客服'
            },
            component:()=>import('@/views/order/cashkefu.vue')
        },
		
        {
            path:'/user/address',
            name:'info',
            meta: {
                title: '我的地址'
            },
            component:()=>import('@/views/user/address.vue')
        },






		//以上为用的的

        {
            path:'/user/photo',
            name:'photo',
            meta: {
                title: '照片'
            },
            component:()=>import('@/views/user/photo.vue')
        },




        {
            path:'/seting/kefu',
            name:'/seting/kefu',
            meta: {
                title: '客服'
            },
            component:()=>import('@/views/setting/kefu.vue')
        },
        {
            path:'/seting/yinsi',
            name:'/seting/yinsi',
            meta: {
                title: '隐私保护'
            },
            component:()=>import('@/views/setting/yinsi.vue')
        },
        {
            path:'/seting/feedback',
            name:'/seting/feedback',
            meta: {
                title: '意见反馈'
            },
            component:()=>import('@/views/setting/feedback.vue')
        },
        {
            path:'/seting/about',
            name:'/seting/about',
            meta: {
                title: '关于我们'
            },
            component:()=>import('@/views/setting/about.vue')
        },

		// 保留 作为B通道 参考样式
        {
            path:'/donate',
            name:'/donate',
            meta: {
                title: '感谢有你支持'
            },
            component:()=>import('@/views/will/donate.vue')
        },
    ]
});
